import { sh } from '@tpluscode/rdf-ns-builders';
export class PathVisitor {
    visit(path, arg) {
        if (path instanceof PredicatePath) {
            return this.visitPredicatePath(path, arg);
        }
        if (path instanceof SequencePath) {
            return this.visitSequencePath(path, arg);
        }
        if (path instanceof AlternativePath) {
            return this.visitAlternativePath(path, arg);
        }
        if (path instanceof InversePath) {
            return this.visitInversePath(path, arg);
        }
        if (path instanceof ZeroOrMorePath) {
            return this.visitZeroOrMorePath(path, arg);
        }
        if (path instanceof OneOrMorePath) {
            return this.visitOneOrMorePath(path, arg);
        }
        if (path instanceof ZeroOrOnePath) {
            return this.visitZeroOrOnePath(path, arg);
        }
        throw new Error('Unexpected path');
    }
}
export class ShaclPropertyPath {
}
export class PredicatePath extends ShaclPropertyPath {
    constructor(term) {
        super();
        this.term = term;
    }
    accept(visitor, arg) {
        return visitor.visitPredicatePath(this, arg);
    }
}
export class SequencePath extends ShaclPropertyPath {
    constructor(paths) {
        super();
        this.paths = paths;
    }
    accept(visitor, arg) {
        return visitor.visitSequencePath(this, arg);
    }
}
export class AlternativePath extends ShaclPropertyPath {
    constructor(paths) {
        super();
        this.paths = paths;
    }
    accept(visitor, arg) {
        return visitor.visitAlternativePath(this, arg);
    }
}
export class InversePath extends ShaclPropertyPath {
    constructor(path) {
        super();
        this.path = path;
    }
    accept(visitor, arg) {
        return visitor.visitInversePath(this, arg);
    }
}
export class ZeroOrMorePath extends ShaclPropertyPath {
    constructor(path) {
        super();
        this.path = path;
    }
    accept(visitor, arg) {
        return visitor.visitZeroOrMorePath(this, arg);
    }
}
export class OneOrMorePath extends ShaclPropertyPath {
    constructor(path) {
        super();
        this.path = path;
    }
    accept(visitor, arg) {
        return visitor.visitOneOrMorePath(this, arg);
    }
}
export class ZeroOrOnePath extends ShaclPropertyPath {
    constructor(path) {
        super();
        this.path = path;
    }
    accept(visitor, arg) {
        return visitor.visitZeroOrOnePath(this, arg);
    }
}
export function fromNode(path, { allowNamedNodeSequencePaths = false } = {}) {
    return transformNode({ allowNamedNodeSequencePaths }, path);
}
function transformNode(options, path) {
    if ('termType' in path) {
        return new PredicatePath(path);
    }
    assertWellFormedPath(path);
    if (path.term.termType === 'NamedNode' && !options.allowNamedNodeSequencePaths) {
        return new PredicatePath(path.term);
    }
    const sequence = path.list();
    if (sequence) {
        const paths = [...sequence];
        assertWellFormedShaclList(paths);
        return new SequencePath(paths.map(transformNode.bind(null, options)));
    }
    if (path.term.termType === 'BlankNode') {
        const inversePath = path.out(sh.inversePath);
        if (inversePath.term) {
            return new InversePath(transformNode(options, inversePath));
        }
        const alternativePath = path.out(sh.alternativePath);
        if (alternativePath.term) {
            const list = [...alternativePath.list() || []];
            assertWellFormedShaclList(list);
            return new AlternativePath(list.map(transformNode.bind(null, options)));
        }
        const zeroOrMorePath = path.out(sh.zeroOrMorePath);
        if (zeroOrMorePath.term) {
            return new ZeroOrMorePath(transformNode(options, zeroOrMorePath));
        }
        const oneOrMorePath = path.out(sh.oneOrMorePath);
        if (oneOrMorePath.term) {
            return new OneOrMorePath(transformNode(options, oneOrMorePath));
        }
        const zeroOrOnePath = path.out(sh.zeroOrOnePath);
        if (zeroOrOnePath.term) {
            return new ZeroOrOnePath(transformNode(options, zeroOrOnePath));
        }
    }
    if (path.term.termType === 'NamedNode' && options.allowNamedNodeSequencePaths) {
        return new PredicatePath(path.term);
    }
    throw new Error(`Unrecognized property path ${path.value}`);
}
export function assertWellFormedPath(ptr) {
    if (!ptr.term) {
        throw new Error('SHACL Path must be single node');
    }
}
function assertWellFormedShaclList(list) {
    if (list.length < 2) {
        throw new Error('SHACL List must have at least 2 elements');
    }
}
//# sourceMappingURL=path.js.map